import { Action, createReducer, on } from '@ngrx/store';
import * as filterActions from '../actions/filter.actions';
import { IFilter } from '@app-root-interfaces';

export const filterFeatureKey = 'filter';

export interface State {
    filters: IFilter;
    search: string;
    all: IFilter;
    searchAll: boolean;
}

export const initialState: State = {
    filters: {
        formats: [],
        languages: [],
        topics: [],
        orgs: []
    },
    search: '',
    all: {
        formats: [],
        languages: [],
        topics: [],
        orgs: []
    },
    searchAll: false
};

const filterReducer = createReducer(
    initialState,
    on(filterActions.changeFilterSuccess, (state, { filter }) => ({
        ...state,
        filters: filter
    })),
    on(filterActions.changeSearch, (state, { search }) => ({
        ...state,
        search
    })),
    on(filterActions.changeSearchAll, (state, { searchAll }) => ({
        ...state,
        searchAll
    })),
    on(filterActions.getAllFiltersSuccess, (state, { filters }) => ({
        ...state,
        all: filters
    })),
    on(filterActions.getAllFiltersFailure, (state) => ({
        ...state,
        all: initialState.all
    })),
    on(filterActions.resetSearch, (state) => ({
        ...state,
        filters: initialState.filters,
        search: ''
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return filterReducer(state, action);
}
